import Program from "../../program.js";
import * as tools from "../../tools.js";
import Font from "../../font.js";
import { SpriteMap, Animation } from "../../graphics.js";
// lodash replaced with native array methods

import miniFontFile from "url:./assets/Graph-35-pix.ttf";

import clickSoundFile from "url:./assets/click.wav";
import doorCloseSoundFile from "url:./assets/door_close.wav";
import doorClosedClickSoundFile from "url:./assets/door_closed_click.wav";
import doorOpenSoundFile from "url:./assets/door_open.wav";
import nextLevelSoundFile from "url:./assets/next_level.wav";
import buttonClickSoundFile from "url:./assets/btn_click.wav";
import checkpointSoundFile from "url:./assets/checkpoint.wav";

import greenCursorFile from "url:./assets/cursor-green.png";
import crystalImageFile from "url:./assets/checkpoint.png";
import spritesImageFile from "url:./assets/sprites.png";

class Cursor {
  constructor(level, aliveImg, deadImg) {
    this.points = 0;
    this.totalTime = 0;
    this.history = {};
    this.lastEntry = {};
    this.currentEntry = this.lastEntry;
    this.isAlive = true;
    this.level = level;
    this.checkpoint = level;
    this.aliveImg = aliveImg;
    this.deadImg = deadImg;
  }
  set level(newLevel) {
    var currLevel = this._level;
    if (currLevel) {
      currLevel.cursors = currLevel.cursors.filter((v) => v !== this);
    }
    newLevel.cursors = [...newLevel.cursors, this];
    this._level = newLevel;
  }
  get level() {
    return this._level;
  }
  get x() {
    return this.currentEntry.x;
  }
  get y() {
    return this.currentEntry.y;
  }
  get clicked() {
    return this.currentEntry.clicked;
  }
  get btnDown() {
    return this.currentEntry.btnDown;
  }
  processInput(mouse) {
    const x = mouse.pos.x,
      y = mouse.pos.y,
      clicked = mouse.clicked,
      btnDown = mouse.btn1Down;
    var cursor = this;
    if (
      this.lastEntry.x != x ||
      this.lastEntry.y != y ||
      this.lastEntry.clicked != clicked ||
      this.lastEntry.btnDown != btnDown
    ) {
      this.lastEntry = this.history[this.totalTime] = {
        x: x,
        y: y,
        clicked: clicked,
        btnDown: btnDown,
      };
    }
  }
  update(delta) {
    this.currentEntry = this.history[this.totalTime] || this.currentEntry;
    this.totalTime += delta;
  }
  reset() {
    this.level = this.checkpoint;
    this.totalTime = 0;
  }
  draw(ctx) {
    ctx.drawImage(this.isAlive ? this.aliveImg : this.deadImg, this.x, this.y);
  }
}

class Item {
  constructor(col, row, width = 16, height = 16) {
    this.col = col;
    this.row = row;
    this.x = col * width;
    this.y = row * height;
    this.width = width;
    this.height = height;
  }
  processInput() {}
  update() {}
  draw() {}
  cursorInBox(cursor) {
    return (
      cursor.x >= this.x &&
      cursor.x < this.x + this.width &&
      cursor.y >= this.y &&
      cursor.y <= this.y + this.height
    );
  }
}
var actions;
function doAction(action) {
  if (actions) {
    actions.push(action);
  } else {
    action();
  }
}
function recordActions(block) {
  actions = [];
  block();
  const savedActions = actions;
  actions = [];
  return () => {
    savedActions.forEach((action) => action());
  };
}
class Checkpoint extends Item {
  constructor(col, row, world, level, checkpointSound, crystalAnimation) {
    super(col, row);
    this.world = world;
    this.level = level;
    this.checkpointSound = checkpointSound;
    this.crystalAnimation = crystalAnimation;
  }

  processInput(cursors, inFocus) {
    if (this.taken) return;
    for (var i = 0; i < cursors.length; i++) {
      const cursor = cursors[i];
      if (cursor.isAlive && cursor.clicked && this.cursorInBox(cursor)) {
        this.world.globalCheckpoint = this.level;
        this.checkpointSound.play();
        this.taken = true;
        break;
      }
    }
  }
  draw(ctx) {
    if (this.taken) return;
    this.crystalAnimation.draw(ctx, this.x, this.y);
  }
}
class Button extends Item {
  constructor(col, row, clickSound, spriteMap) {
    super(col, row);
    this.isPressed = false;
    this.clickSound = clickSound;
    this.buttonAnimation = new Animation(spriteMap, 12, [16, 17, 18], false);
    this.buttonAnimation.pause();
  }
  processInput(cursors, inFocus) {
    var anyBtnDown = false;
    for (var i = 0; i < cursors.length; i++) {
      const cursor = cursors[i];
      if (cursor.btnDown && this.cursorInBox(cursor)) {
        anyBtnDown = true;
        break;
      }
    }
    if (inFocus && !this.isPressed && anyBtnDown) {
      this.clickSound.play();
    }
    if (this.isPressed) {
      this.buttonAnimation.play();
    } else {
      this.buttonAnimation.reverse();
    }
    this.isPressed = anyBtnDown;
  }
  update(delta) {
    this.buttonAnimation.update(delta);
  }
  draw(ctx) {
    //ctx.fillStyle = this.isPressed ? "#FFFFFF" : "#FF00FF";
    //ctx.fillRect(this.x, this.y, this.width, this.height);
    this.buttonAnimation.draw(ctx, this.x, this.y);
  }
}

class Door extends Item {
  constructor(
    col,
    row,
    isOpen = () => false,
    level,
    openSound,
    closeSound,
    closedClickSound,
    nextLevelSound,
    spriteMap,
    stairsIdx,
  ) {
    super(col, row);
    this.isOpen = isOpen;
    this.lastOpen = isOpen();
    this.slidePos = this.lastOpen ? 16 : 0;
    this.openSound = openSound;
    this.closeSound = closeSound;
    this.closedClickSound = closedClickSound;
    this.nextLevelSound = nextLevelSound;
    this.spriteMap = spriteMap;
    this.stairsIdx = stairsIdx;
    this.doorAnimation = new Animation(spriteMap, 12, [4, 5, 6, 7, -1], false);
    this.getLevel = (createIfNotExist = true) => {
      if (!this._level && createIfNotExist) {
        this._level = level();
      }
      return this._level;
    };
    this.reset();
  }
  processInput(cursors, inFocus) {
    if (inFocus) {
      if (!this.lastOpen && this.isOpen()) {
        this.openSound.play();
      } else if (this.lastOpen && !this.isOpen()) {
        this.closeSound.play();
      }
    }
    this.lastOpen = this.isOpen();

    cursors.forEach((cursor) => {
      if (!inFocus && !this.isOpen()) return;

      if (cursor.clicked && this.cursorInBox(cursor)) {
        if (this.isOpen()) {
          inFocus && this.nextLevelSound.play();
          doAction(() => {
            cursor.level = this.getLevel();
          });
        } else {
          inFocus && this.closedClickSound.play();
        }
      }
    });
  }
  reset() {
    this.doorAnimation.reset();
    if (this.lastOpen) {
      this.doorAnimation.frameIdx = 4;
    }
  }
  update(delta) {
    if (this.isOpen()) {
      this.doorAnimation.play();
    } else if (!this.isOpen()) {
      this.doorAnimation.reverse();
    }
    this.doorAnimation.update(delta);
  }
  draw(ctx) {
    this.spriteMap.draw(ctx, this.x, this.y, this.stairsIdx);
    this.doorAnimation.draw(ctx, this.x, this.y);
  }
}

class Box extends Item {
  constructor(col, row, power, font, clickSound, spriteMap, miniFont) {
    super(col, row);
    this.startPower = power;
    this.power = power;
    this.font = font;
    this.totalTime = 0;
    this.shake = 0;
    this.clickSound = clickSound;
    this.potAnimation = new Animation(
      spriteMap,
      12,
      [52, 53, 53, 53, 54, 54, 54, 55],
      false,
    );
    this.miniFont = miniFont;
    this.reset();
    this.points = [];
  }
  reset() {
    this.power = this.startPower;
    this.potAnimation.pause();
    this.potAnimation.reset();
  }
  update(delta) {
    this.totalTime += delta;
    this.shake *= 10 / delta;

    this.xOffs = Math.sin(this.totalTime / 3.3) * this.shake;
    this.yOffs = Math.cos(this.totalTime / 2.1) * this.shake;
    this.potAnimation.update(delta);
    this.points.forEach((point) => {
      point.time += delta;
      if (point.time > 2000)
        this.points = this.points.filter((p) => p !== point);
    });
  }
  processInput(cursors, inFocus) {
    if (this.power <= 0) return;

    var inFocusCursorClicked = false;
    cursors.forEach((cursor) => {
      if (cursor.clicked && this.cursorInBox(cursor)) {
        if (this.power == 0) return;
        if (inFocus) inFocusCursorClicked = true;
        this.power--;
        this.shake += 2;
        cursor.points += 1;
        if (cursor.isAlive)
          this.points = [
            ...this.points,
            {
              x: cursor.x + Math.sin(Math.random() * Math.PI * 2) * 5,
              y: cursor.y + Math.sin(Math.random() * Math.PI * 2) * 5,
              time: 0,
              offs: Math.random() * Math.PI * 2,
            },
          ];
        if (this.power == 0) {
          this.potAnimation.play();
        }
      }
    });
    inFocusCursorClicked && this.clickSound.play();
  }
  draw(ctx) {
    const x = this.x + this.xOffs;
    const y = this.y + this.yOffs;
    this.potAnimation.draw(ctx, x, y);
    ctx.fillStyle = "#FF0000";
    ctx.fillRect(
      this.x,
      this.y,
      (this.power / this.startPower) * this.width,
      2,
    );

    this.points.forEach((point) => {
      const xOffs = Math.sin(point.time / 100 + point.offs);
      const yOffs = -point.time / 40;
      if (point.time > 1000 && point.time % 200 > 100) return;

      this.miniFont.draw(
        ctx,
        "+1",
        point.x + xOffs,
        point.y + yOffs,
        8,
        6,
        7,
        "#FFFFFF",
      );
    });
  }
}

function makeRandom(seed = 1) {
  return function random() {
    const x = Math.sin(seed++) * 10000;
    return x - Math.floor(x);
  };
}

const pointer_frenzy = new Program((computer) => {
  const startInfiniteBuzz = () => {
    computer.graphics.videoCable.features.buzz().then(startInfiniteBuzz);
  };
  startInfiniteBuzz();
  const random = makeRandom(0.27);
  class Level {
    constructor(
      name,
      boxCount,
      difficulty,
      previousLevel,
      sounds,
      world,
      animations,
      images,
      spriteMap,
      miniFont,
    ) {
      this.idx = previousLevel ? previousLevel.idx + 1 : 0;
      this.world = world;
      this.name = name;
      this.items = [];
      this.cursors = [];
      this.boxes = [];
      this.sounds = sounds;
      this.animations = animations;
      this.images = images;
      this.spriteMap = spriteMap;
      this.miniFont = miniFont;

      const cols = 20;
      const rows = 12;

      const grid = new Array(rows * cols);
      for (var i = 0; i < grid.length; i++) {
        grid[i] = i;
      }

      grid.splice(0, cols); //Remove the first row to make room for menu
      if (previousLevel) {
        const doorFromPrevLevel = previousLevel.exit;
        const entrance = new Door(
          doorFromPrevLevel.col,
          doorFromPrevLevel.row,
          doorFromPrevLevel.isOpen,
          () => previousLevel,
          sounds.doorOpen,
          sounds.doorClose,
          sounds.doorClosedClick,
          sounds.nextLevel,
          spriteMap,
          7 * 16 + 10,
        );
        this.items.push(entrance);

        const gridPos = doorFromPrevLevel.col + doorFromPrevLevel.row * cols;
        grid.splice(grid.indexOf(gridPos), 1);
      }

      grid.sort(() => 0.5 - random()); //shuffle

      var gridPos = 0;
      const nextPos = () => {
        const gridIdx = grid[gridPos++];
        return { row: Math.floor(gridIdx / cols), col: gridIdx % cols };
      };

      this.totalPower = 0;
      for (var i = 0; i < boxCount; i++) {
        const pos = nextPos();
        const power = Math.min(99, 1 + Math.ceil(random() * 100 * difficulty));
        this.totalPower += power;
        const box = new Box(
          pos.col,
          pos.row,
          power,
          computer.systemFont,
          this.sounds.click,
          this.spriteMap,
          this.miniFont,
        );
        this.items.push(box);
        this.boxes.push(box);
      }

      if (this.idx % 4 == 3) {
        const cpPos = nextPos();
        const checkpoint = new Checkpoint(
          cpPos.col,
          cpPos.row,
          this.world,
          this,
          this.sounds.checkpoint,
          this.animations.crystal,
        );
        this.items.push(checkpoint);
      }

      var btns = [];
      while (random() > 0.798) {
        const btnPos = nextPos(),
          btn = new Button(
            btnPos.col,
            btnPos.row,
            this.sounds.clickButton,
            this.spriteMap,
          );
        btns.push(btn);
        this.items.push(btn);
      }
      const allBtnsPressed = () => {
        return (
          btns.length == 0 ||
          btns.reduce((acc, btn) => {
            return acc && btn.isPressed;
          }, true)
        );
      };

      const j = this.idx;
      const exitPos = nextPos();
      const doorOpen = () =>
        allBtnsPressed() &&
        this.boxes.filter((box) => box.power > 0).length == 0;
      const exit = new Door(
        exitPos.col,
        exitPos.row,
        doorOpen,
        () =>
          new Level(
            "Level " + (j + 1),
            2 + j * 0.2,
            0.005 * j,
            this,
            sounds,
            world,
            this.animations,
            this.images,
            this.spriteMap,
            this.miniFont,
          ),
        sounds.doorOpen,
        sounds.doorClose,
        sounds.doorClosedClick,
        sounds.nextLevel,
        spriteMap,
        7 * 16 + 9,
      );
      this.items.push(exit);
      this.exit = exit;
    }
    reset() {
      this.boxes.forEach((box) => box.reset());
      this.exit.reset();
    }
    update(delta) {
      this.items.forEach((item) => item.update(delta));
    }

    processInput(inFocus) {
      this.items.forEach((item) => item.processInput(this.cursors, inFocus));
      this.powerLeft = this.boxes.reduce((acc, box) => {
        return acc + box.power;
      }, 0);
    }

    draw(ctx) {
      computer.systemFont.draw(
        ctx,
        "LEVEL - " + this.name,
        0,
        0,
        8,
        8,
        8,
        "#FF00FF",
      );
      this.items.forEach((item) => item.draw(ctx));
      this.cursors.forEach((cursor) => {
        !cursor.isAlive && cursor.draw(ctx);
      });
    }
  }

  class World {
    constructor(assets, miniFont, maxTime = 5000) {
      const greenCursorImg = assets[0];
      this.sounds = {};
      this.sounds.click = assets[1];
      this.sounds.doorOpen = assets[2];
      this.sounds.doorClose = assets[3];
      this.sounds.nextLevel = assets[4];
      this.sounds.clickButton = assets[5];
      this.sounds.doorClosedClick = assets[6];
      this.sounds.checkpoint = assets[7];
      this.animations = {};
      this.animations.crystal = new Animation(new SpriteMap(assets[8]), 8);
      this.spriteMap = new SpriteMap(assets[9]);
      this.miniFont = miniFont;

      this.cellar = new Level(
        "Cellar",
        1,
        0,
        undefined,
        this.sounds,
        this,
        this.animations,
        this.images,
        this.spriteMap,
        this.miniFont,
      );
      this.globalCheckpoint = this.cellar;
      this.currentCursor = new Cursor(
        this.cellar,
        computer.resources.cursorImg,
        greenCursorImg,
      );
      this.totalTime = 0;
      this.maxTime = maxTime;
    }
    get activeLevel() {
      return this.currentCursor.level;
    }
    processInput(mouse) {
      this.currentCursor.processInput(mouse);
    }
    eachLevel(func) {
      var level = this.cellar;
      do {
        func(level);
      } while ((level = level.exit.getLevel(false)) != undefined);
    }
    update(delta) {
      recordActions(() => {
        this.eachLevel((level) => {
          level.update(delta);
          level.cursors.forEach((cursor) => {
            cursor.update(delta);
          });
          level.processInput(this.activeLevel == level);
        });
      })();

      this.totalTime += delta;
      if (this.totalTime >= this.maxTime) {
        this.restart();
      }
      this.animations.crystal.update(delta);
    }
    draw(ctx) {
      const timeMeterY = (this.totalTime / this.maxTime) * 200;
      ctx.fillStyle = "#000000";
      ctx.fillRect(0, 0, 320, 200);

      ctx.fillStyle = "#300511";
      ctx.fillRect(0, timeMeterY, 320, 200 - timeMeterY);

      const powerMeterY =
        ((this.activeLevel.totalPower - this.activeLevel.powerLeft) /
          this.activeLevel.totalPower) *
        200;
      ctx.fillStyle = "#110530";
      ctx.fillRect(10, powerMeterY, 300, 200 - powerMeterY);

      this.activeLevel.draw(ctx);
      //Draw the current alive cursor on top of the others.
      this.currentCursor.draw(ctx);
      computer.systemFont.draw(
        ctx,
        "POINTS: " + this.currentCursor.points,
        0,
        8,
        8,
        8,
        8,
        "#FFFFFF",
      );
    }
    restart() {
      this.totalTime = 0;

      //Reset levels and move cursors to their checkpoints
      this.eachLevel((level) => {
        level.cursors.forEach((cursor) => cursor.reset());
        level.reset();
      });

      const oldPoints = this.currentCursor.points;
      this.currentCursor.isAlive = false;
      this.currentCursor = new Cursor(
        this.globalCheckpoint,
        this.currentCursor.aliveImg,
        this.currentCursor.deadImg,
      );
      this.currentCursor.points = oldPoints;
    }
  }

  function loadSound(file) {
    return new Promise((resolve, reject) => {
      const sound = new Howl({
        src: [file],
        preload: true,
        onload: () => resolve(sound),
      });
    });
  }
  const miniFont = new Font("Berkelium64", 255, miniFontFile);

  return Promise.all([
    tools.loadImage(greenCursorFile),
    loadSound(clickSoundFile),
    loadSound(doorOpenSoundFile),
    loadSound(doorCloseSoundFile),
    loadSound(nextLevelSoundFile),
    loadSound(buttonClickSoundFile),
    loadSound(doorClosedClickSoundFile),
    loadSound(checkpointSoundFile),
    tools.loadImage(crystalImageFile),
    tools.loadImage(spritesImageFile),
    miniFont.load(),
  ]).then((assets) => {
    const world = new World(assets, miniFont, 14000 * 1);
    return {
      begin: () => {
        world.processInput(computer.mouse);
      },
      update: (delta) => {
        world.update(delta);
      },
      draw: (interpolationPercentage) => {
        const ctx = computer.graphics.ctx;
        ctx.clearRect(0, 0, 320, 200);

        world.draw(ctx);
      },
    };
  });
});
export default pointer_frenzy;
